export default __webpack_public_path__ + "static/media/iCashCard.a868a622.svg";